import { getComposeStoreManager } from '../store/store';
import { getLegacyComposeStore } from '../store/legacyStore';
import { isFeatureEnabled } from 'owa-feature-flags';

export function getComposeStore(formId?: string) {
    if (isFeatureEnabled('cal-multiple-compose-forms') && formId) {
        return getComposeStoreManager().storeMap.get(formId);
    } else {
        return getLegacyComposeStore();
    }
}
